(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("adminsUsersService", AdminsUsersService);

    AdminsUsersService.$inject = ['$q'];

    function AdminsUsersService($q) {
        var self = this;
        var _brandId;
        var _admins = [];

        self.getLoadAdminUsersPolicy = function (brandId, permissions) {
            var defer = $q.defer();
            _brandId = brandId;
            var cachedBrandPermission = _admins[_brandId] && Object.keys(_admins[_brandId]) || [];

            if (cachedBrandPermission.length > 0) {
                var isAllPermissionsCached = permissions.every(function (item) {
                    return cachedBrandPermission.includes(item);
                });

                if (isAllPermissionsCached) {
                    var adminUsersPolicy = new AdminUsersPolicy(brandId, permissions);
                    adminUsersPolicy.LoadAdmins(_admins[_brandId]);
                    defer.resolve(adminUsersPolicy);
                } else {
                    loadAdminUsersPerPermission(brandId, permissions)
                        .then(function (admins) {
                            var adminUsersPolicy = new AdminUsersPolicy(brandId, permissions);
                            adminUsersPolicy.LoadAdmins(admins);
                            defer.resolve(adminUsersPolicy);
                        })
                        .catch(function (err) {
                            defer.reject(err);
                        });
                }
            } else {
                loadAdminUsersPerPermission(brandId, permissions)
                    .then(function (admins) {
                        var adminUsersPolicy = new AdminUsersPolicy(brandId, permissions);
                        adminUsersPolicy.LoadAdmins(admins);
                        defer.resolve(adminUsersPolicy);
                    })
                    .catch(function (err) {
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        var loadAdminUsersPerPermission = function (brandId, permissions) {
            var defer = $q.defer();
            UserAPI.getEmployees(brandId, permissions)
                .then(function (res) {
                    _admins[_brandId] =  _admins[_brandId] || {};
                    for (var admin in res.users) {
                        res.users[admin]['name'] = res.users[admin]['first_name'] + ' ' + res.users[admin]['last_name'];
                        for (var j in res.users[admin].permissions) {
                            var permissionCode = res.users[admin].permissions[j].code;
                            _admins[_brandId][permissionCode] =_admins[_brandId][permissionCode] ||[];
                            _admins[_brandId][permissionCode].push(res.users[admin]);
                        }
                    }

                    defer.resolve(_admins[_brandId]);
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };
    }

    var AdminUsersPolicy = function(brandId, permissions) {
        var self = this;
        self.brandId = brandId;
        self.permissions = permissions;
        var _admins = [];

        self.LoadAdmins = function(admins){
            _admins = JSON.parse(JSON.stringify(admins));
        };

        self.getAdminUsersPerPermission = function () {
            return _admins;
        };

        self.getUnionAdminUsersPerPermission = function (permissions) {
            var adminsList = [];
            for (var i in permissions) {
                if (_admins[permissions[i]]) {
                    adminsList = adminsList.concat(_admins[permissions[i]]);
                }
            }

            var uniqueAdminsList = adminsList.filter(function (obj, index) {
                return index === adminsList.findIndex(function (o) {
                    return obj.id === o.id;
                });
            });

            return uniqueAdminsList;
        }

        self.getAdminUsersPerCategory = function (adminsPerPermission, allCategories, allPermissions) {
            var adminsPerCategory = [];

            for (var i in adminsPerPermission) {
                var user = {
                    id: adminsPerPermission[i].id,
                    first_name: adminsPerPermission[i].first_name,
                    last_name: adminsPerPermission[i].last_name,
                    name: adminsPerPermission[i].first_name + " " + adminsPerPermission[i].last_name,
                    permissions: adminsPerPermission[i].permissions
                };

                for (var permission in adminsPerPermission[i].permissions) {
                    if (adminsPerPermission[i].permissions[permission].is_allowed_all_categories) {
                        var allCategoriesCodes = [];
                        for (var cat in allCategories) {
                            allCategoriesCodes.push(allCategories[cat].code);
                        }
                        adminsPerPermission[i].permissions[permission].categories = allCategoriesCodes;
                    } else {
                        adminsPerPermission[i].permissions[permission].categories.push('OTHER');
                    }

                    var categoriesPermission = adminsPerPermission[i].permissions[permission].code;
                    if (adminsPerPermission[i].permissions[permission].categories) {
                        for (var j in adminsPerPermission[i].permissions[permission].categories) {
                            var category = adminsPerPermission[i].permissions[permission].categories[j];
                            if (!adminsPerCategory[category]) {
                                adminsPerCategory[category] = [];
                            }
                            var found = _.findWhere(adminsPerCategory[category], {id: user.id});
                            var hasRightPermission =  allPermissions.includes(categoriesPermission);

                            if (!found && hasRightPermission) {
                                adminsPerCategory[category].push(user);
                            }
                        }
                    }

                    if (adminsPerPermission[i].permissions[permission].is_allowed_all_categories) {
                        adminsPerPermission[i].permissions[permission].categories = [];
                    }
                }
            }

            return adminsPerCategory;
        };
    };
})();
